import React, { useState, useEffect, PropsWithChildren } from "react";
import { observer } from "mobx-react-lite";
import { Header } from "./components/patterns/Header";
import { Body } from "./components/patterns/Body";
import { Wrapper } from "./Layout.styles";
import { useMst } from "../../mobx";
import { useLocation } from "react-router-dom";

function Layout({ children }: PropsWithChildren<{}>) {
	return <Wrapper>{children}</Wrapper>;
}

Layout.Header = Header;
Layout.Body = Body;

export default observer(function () {
	const { authStore } = useMst();
	const { me } = authStore;
	const [openDrawer, setOpenDrawer] = useState(true);
	const { pathname } = useLocation();
	const [loading, setLoading] = useState(true);

	useEffect( () => {
		async function getMe() {
			setLoading(true)
			await me();
			setLoading(false)
		}
		getMe();
	}, []);

	useEffect(() => {
		if (pathname.includes("create") || pathname.includes("edit")) {
			setOpenDrawer(false);
		}
	}, [pathname]);

	return (
		<Layout>
			<Layout.Header open={openDrawer} onDrawerOpen={() => setOpenDrawer(true)} />
			<Layout.Body open={openDrawer} loading={loading} onDrawerClose={() => setOpenDrawer(false)} />
		</Layout>
	);
});
